import isArray from 'lodash/isArray';

export const getFormattedDisabledDaysOfWeek = disabledDaysOfWeek => {
  if (!disabledDaysOfWeek || !isArray(disabledDaysOfWeek)) {
    return [];
  }

  const formattedArray = disabledDaysOfWeek.map(dayIndex => {
    if (dayIndex === 7) {
      return 0;
    }
    return dayIndex;
  });

  // eslint-disable-next-line no-constant-binary-expression -- FIXME
  return [...new Set(formattedArray)] ?? [];
};
